var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcResume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-rc-resume",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 38.68444445C251.02108445 38.68444445 38.68444445 251.02108445 38.68444445 512s212.33664 473.31555555 473.31555555 473.31555555 473.31555555-212.33664 473.31555555-473.31555555S772.97891555 38.68444445 512 38.68444445z m0 873.81333333C291.18008889 912.49777778 111.50222222 732.81991111 111.50222222 512S291.18008889 111.50222222 512 111.50222222s400.49777778 179.67786667 400.49777778 400.49777778-179.67786667 400.49777778-400.49777778 400.49777778z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M460.59064889 299.19004445a36.40888889 36.40888889 0 0 0-57.81731556 29.4547911v386.58958223a36.40888889 36.40888889 0 0 0 57.81731556 29.41838222l265.78488889-193.29479111a36.40888889 36.40888889 0 0 0 0-58.90958222l-265.78488889-193.25838222z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcResume);
export default __webpack_public_path__ + "static/media/rc-resume.a57e6165a9a7d7e61a13ff6774bef6e1.svg";
export { ForwardRef as ReactComponent };